export const EN_US: string = 'en-US';

export enum DateFormats {
    DDMMYYYY = 'dd/MM/yyyy',
    MMDDYYYY = 'MM/dd/yyyy'
}
